export default function get(obj, path) {
    return path.split(".").reduce((acc, part) => acc && acc[part], obj);
}
//# sourceMappingURL=get.js.map